<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <!-- Drop zone (shown when no file selected and not uploading) -->
  @if (!file && !progress) {
    <div
      class="drop-zone"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [class.hovering]="isDragOver"
      >
      <mat-icon>cloud_upload</mat-icon>
      <p>Drag & drop file here or</p>
      <button mat-raised-button color="primary" (click)="fileInput.click()">Choose File</button>
      <input #fileInput type="file" hidden (change)="onFileSelected($event)" [attr.accept]="acceptAttr">
      <p class="hint">{{ hintText }}</p>
    </div>
  }

  @if (validationError) {
    <div class="validation-error">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ validationError }}</span>
    </div>
  }

  <!-- File selected, ready to upload -->
  @if (file && !progress) {
    <div class="upload-info">
      <div class="file-details">
        <mat-icon>insert_drive_file</mat-icon>
        <span class="file-name">{{ file.name }}</span>
        <span class="file-size">{{ formatFileSize(file.size) }}</span>
        <button mat-icon-button (click)="onRemoveFile()" matTooltip="Remove file">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Upload progress (shown after upload started) -->
  @if (file && progress) {
    <div class="upload-info">
      <div class="file-details">
        <mat-icon>insert_drive_file</mat-icon>
        <span class="file-name">{{ file.name }}</span>
        <span class="file-size">{{ formatFileSize(file.size) }}</span>
      </div>
      <mat-progress-bar [mode]="progressMode" [value]="progress.percentage || 0"></mat-progress-bar>
      <p class="status" [class.error]="isError" [class.done]="isDone">{{ statusText }}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (canStartUpload) {
    <button mat-raised-button (click)="startUpload()" color="primary">Upload</button>
  }
  @if (canPause) {
    <button mat-button (click)="onPause()">Pause</button>
  }
  @if (canResume) {
    <button mat-button (click)="onResume()">Resume</button>
  }
  @if (canCancel) {
    <button mat-button (click)="onCancel()" color="warn">Cancel</button>
  }
  @if (isDone) {
    <button mat-raised-button (click)="onClose()" color="primary">Done</button>
  }
  @if (isError) {
    <button mat-button (click)="onCancel()">Close</button>
  }
</mat-dialog-actions>
